import type { BuilderCompData } from '@wix/thunderbolt-symbols'

export type EditableComponentUrls = {
	JSX: string
	SDK: string
	npmModuleName: string
}

export const buildEditorReactComponentMapping = (
	builderComponents: { [componentType: string]: BuilderCompData },
	experiments: Record<string, string | boolean> = {}
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	Object.values(builderComponents).forEach((component: BuilderCompData) => {
		const { componentType, componentUrl, sdkUrl, moduleSpecifier } = component

		if (moduleSpecifier && componentUrl) {
			mapping[moduleSpecifier] = componentUrl
		}
		if (moduleSpecifier && sdkUrl) {
			mapping[`${moduleSpecifier}/sdk`] = sdkUrl
		}
	})

	return mapping
}
